export const blockIconsPlacesSpa = (
	<span className='material-symbols-outlined'>spa</span>
);
